import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Grid,
  Dialog,
  DialogContent,
  CircularProgress,
} from '@mui/material';
import InfoRow from './InfoRow';
import { Base64Image } from '../../../../utils/settings';
import { getPancardImageAction } from '../../Beneficiary/APIs/action';
import { DownloadOutlined } from "@mui/icons-material";
import { toCapitalized } from "../../../Utils/Capitalize";
import { useSelector } from 'react-redux';
import {
  downloadAction,
  handleDownload,
} from "../../../../v3/Common/Download Button/downloadAction";
import { BenefitInsuraceCardUrl } from "../APIs/url";
import { toast } from "react-toastify";
import { isValidEntityId } from "../../../../v3/Common/Entity/actions/reduxActions";

const PolicySection = ({
  policy_details,
  insuranceType,
  selectedCompanyEntity,
}) => {
  const { beneficiary_list = [], details = [] } = policy_details;
  const [selectedValue, setSelectedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.user?.userData);

  useEffect(() => {
    if (beneficiary_list?.length > 0) {
      setSelectedValue(beneficiary_list[0].value);
    }
  }, [beneficiary_list]);

  // Add service worker message listener for download handling
  useEffect(() => {
    const handleServiceWorkerMessage = (event) => {
      if (event.data && event.data.type === "DOWNLOAD_READY") {
        const { url, filename, mimeType } = event.data;

        // For Android WebView and PWA
        const isAndroidWebView =
          window.navigator.userAgent.includes("wv") &&
          /Android/i.test(navigator.userAgent);

        if (isAndroidWebView) {
          console.log("Android WebView detected, using blob URL for download");

          // Try to use AndroidInterface first (most reliable)
          if (
            window.AndroidInterface &&
            typeof window.AndroidInterface.downloadUrl === "function"
          ) {
            console.log("Using AndroidInterface.downloadUrl for download");
            window.AndroidInterface.downloadUrl(url, filename);
          }
          // Try to use downloadFile method if available (passing the whole blob as base64)
          else if (
            window.AndroidInterface &&
            typeof window.AndroidInterface.downloadFile === "function"
          ) {
            console.log("Using AndroidInterface.downloadFile for download");
            // For this approach, we would need the base64 data again, but we'll use direct URL navigation instead
            window.AndroidInterface.downloadFile(null, filename, mimeType, url);
          }
          // Fallback to direct URL navigation
          else {
            console.log("Falling back to direct URL navigation");
            window.location.href = url;
          }
        } else {
          // For other environments, use iframe method
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.src = url;
          document.body.appendChild(iframe);

          // Clean up after a delay
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 2000);
        }
      }
    };

    navigator.serviceWorker.addEventListener(
      "message",
      handleServiceWorkerMessage,
    );

    return () => {
      navigator.serviceWorker.removeEventListener(
        "message",
        handleServiceWorkerMessage,
      );
    };
  }, []);

  const selectedData = details.find((d) =>
    d.beneficiary_details?.some(
      (b) =>
        b.display_name === "Beneficiary Name" &&
        b.display_value === selectedValue,
    ),
  );
  const [openImage, setOpenImage] = useState(false);
  const [imageBase64, setImageBase64] = useState("");
  const [beneficiaryImageError, setBeneficiaryImageError] = useState("");
  const [nomineeImageError, setNomineeImageError] = useState("");
  const [openCardModal, setOpenCardModal] = useState(false);

  const handleViewImage = (id, type) => {
    getPancardImage(id, type);
  };
  const handleClose = () => {
    setOpenImage(false);
    setImageBase64("");
  };

  // const handleOpenCardModal = () => {
  //   // Track eCard view event
  //   trackAnalyticsEvent('INSURANCE_DETAILS_VIEW_ECARD_CLICK', {
  //     manufacturer_id: userData?.manufacturer_id || '',
  //     benefit_type: insuranceType || '',
  //     beneficiary_name: selectedValue || ''
  //   });

  //   setOpenCardModal(true);

  //   // Track eCard modal load event
  //   trackAnalyticsEvent('INSURANCE_DETAILS_ECARD_MODAL_LOAD', {
  //     manufacturer_id: userData?.manufacturer_id || '',
  //     benefit_type: insuranceType || '',
  //     beneficiary_name: selectedValue || ''
  //   });
  // };

  // const handleCloseCardModal = () => {
  //   // Track eCard modal close event
  //   trackAnalyticsEvent('INSURANCE_DETAILS_ECARD_MODAL_CLOSE', {
  //     manufacturer_id: userData?.manufacturer_id || '',
  //     benefit_type: insuranceType || '',
  //     beneficiary_name: selectedValue || '',
  //     close_method: 'close_button'
  //   });

  //   setOpenCardModal(false);
  // };
  const getPancardImage = async (id, type) => {
    const { error, data } = await getPancardImageAction(id);

    if (!error && data?.pancard_image) {
      setImageBase64(data.pancard_image);
      setOpenImage(true);
      if (type === "beneficiary") {
        setBeneficiaryImageError("");
      } else {
        setNomineeImageError("");
      }
    } else {
      setImageBase64("");
      if (type === "beneficiary") {
        setBeneficiaryImageError("No Image Found");
      } else {
        setNomineeImageError("No Image Found");
      }
    }
  };
  const DetailFieldWithImage = ({ openImage, handleClose }) => (
    <Dialog open={openImage} onClose={handleClose} maxWidth="sm">
      <DialogContent sx={{ textAlign: "center" }}>
        <Base64Image
          base64String={imageBase64}
          style={{ width: "400px", marginBottom: "10px" }}
        />
      </DialogContent>
    </Dialog>
  );

  // const renderInsuranceCard = () => {
  //   const dobValue = selectedData?.beneficiary_details?.find( item => item.display_name === 'Beneficiary D.O.B')?.display_value || '';
  //   const calculatedAge = dobValue ? getAge(dobValue) : null;
  //   const isLifeInsurance = insuranceType?.toLowerCase().includes('life');
  //   const isMedicalInsurance = insuranceType?.toLowerCase().includes('medical');
  //   const cardData = {
  //     name: selectedData?.beneficiary_details?.find( item => item.display_name === 'Beneficiary Name')?.display_value || '',
  //     policy_number: selectedData?.policy_no  || '',
  //     age: calculatedAge || '',
  //     validity: selectedData?.beneficiary_details?.find(item => item.display_name === 'Expiry Date')?.display_value || '',
  //     group: 'Twenty Point Nine Five Venture Pvt. Ltd.',
  //     id_number: selectedData?.certificate_id || '',
  //   };

  //   if (isLifeInsurance) {
  //     return (
  //       <LifeInsuranceCard
  //         name={toCapitalized(cardData.name)}
  //         policy_number={cardData.policy_number}
  //         age={cardData.age}
  //         id_number={cardData.id_number}
  //         validity={cardData.validity}
  //         group={cardData.group}
  //       />
  //     );
  //   } else if (isMedicalInsurance) {
  //     return (
  //       <MedicalInsuranceCard
  //         name={toCapitalized(cardData.name)}
  //         policy_number={cardData.policy_number}
  //         age={cardData.age}
  //         id_number={cardData.id_number}
  //         validity={cardData.validity}
  //         group={cardData.group}
  //       />
  //     );
  //   } else {
  //     return (
  //       'No card available for this insurance type.'
  //     );
  //   }
  // };

  const handleDownloadECard = async () => {
    if (isLoading) return;
    // Guard: on a hard reload / deep link, router state (and thus
    // selectedCompanyEntity) is lost, which sent company_esi_id=undefined
    // (PLAT-10484). Abort with feedback instead of firing a bad request.
    if (!isValidEntityId(selectedCompanyEntity)) {
      toast.error("Unable to download the card right now.");
      return;
    }
    setIsLoading(true);
    const queryParams = new URLSearchParams();
    queryParams.append("company_esi_id", selectedCompanyEntity);
    queryParams.append("insurance_type", insuranceType);
    if (selectedData?.beneficiary_id)
      queryParams.append("beneficiary_id", selectedData.beneficiary_id);
    handleDownload(
      () => downloadAction(BenefitInsuraceCardUrl, queryParams, "E-card.pdf"),
      setIsLoading,
    );
  };

  return (
    <Box sx={{ border: "1px solid #d9d9d9", p: 2, borderRadius: "16px" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Beneficiary Details
      </Typography>

      {beneficiary_list.length > 1 ? (
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="beneficiary-select-label">
            Select Beneficiary
          </InputLabel>
          <Select
            labelId="beneficiary-select-label"
            id="beneficiary-select"
            value={selectedValue}
            label="Select Beneficiary"
            onChange={(e) => setSelectedValue(e.target.value)}>
            <MenuItem value="" disabled>
              -- Select Beneficiary --
            </MenuItem>
            {beneficiary_list.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {toCapitalized(item.label || "")}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <TextField
          size="small"
          fullWidth
          label="Beneficiary"
          value={toCapitalized(beneficiary_list[0]?.label) || ""}
          variant="outlined"
          disabled
          sx={{ mb: 2 }}
          InputProps={{
            readOnly: true,
          }}
        />
      )}
      {selectedData ? (
        <>
          <Box>
            {selectedData.beneficiary_details?.map((item, idx) => (
              <InfoRow
                key={idx}
                label={item.display_name}
                value={item.display_value}
                onViewClick={
                  item.display_name === "Identification proof"
                    ? () =>
                        handleViewImage(
                          selectedData?.beneficiary_id,
                          "beneficiary",
                        )
                    : undefined
                }
                error={
                  item.display_name === "Identification proof"
                    ? beneficiaryImageError
                    : ""
                }
              />
            ))}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12}>
                {/* <Button
                    variant="outlined"
                    endIcon={<Visibility />}
                    sx={{ mt: 1 }}
                    fullWidth
                    onClick={handleOpenCardModal}
                  >
                    E-Card
                  </Button> */}
                <Button
                  variant="outlined"
                  endIcon={!isLoading && <DownloadOutlined />}
                  sx={{
                    mt: 1,
                    minHeight: "40px",
                  }}
                  fullWidth
                  onClick={handleDownloadECard}
                  disabled={isLoading}>
                  {isLoading ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={20} />
                      <span>Downloading...</span>
                    </Box>
                  ) : (
                    "E-card"
                  )}
                </Button>
              </Grid>
            </Grid>
            {selectedData.nominee_detail?.length > 0 && (
              <Box>
                <Typography variant="h3" sx={{ mb: 2 }}>
                  Nominee Details
                </Typography>
                {selectedData.nominee_detail.map((item, idx) => (
                  <InfoRow
                    key={idx}
                    label={item.display_name}
                    value={item.display_value}
                    onViewClick={
                      item.display_name === "Identification proof"
                        ? () =>
                            handleViewImage(selectedData?.nominee_id, "nominee")
                        : undefined
                    }
                    error={
                      item.display_name === "Identification proof"
                        ? nomineeImageError
                        : ""
                    }
                  />
                ))}
              </Box>
            )}
          </Box>
        </>
      ) : (
        <Typography variant="body1" color="text.secondary">
          No details available for the selected beneficiary.
        </Typography>
      )}
      <DetailFieldWithImage
        openImage={openImage}
        imageBase64={imageBase64}
        handleClose={handleClose}
      />
      {/* <ReusableModal
          open={openCardModal}
          onClose={handleCloseCardModal}
          title="E-card"
          subtitle={insuranceType}
        >
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}>
            {renderInsuranceCard()}
             <Button
                variant="outlined"
                endIcon={!isLoading && <DownloadOutlined />}
                sx={{ 
                  mt: 1,
                  minHeight: '40px',
                }}
                fullWidth
                onClick={handleDownloadECard}
                disabled={isLoading}
              >
                {isLoading ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={20} />
                    <span>Downloading...</span>
                  </Box>
                ) : (
                  'Download E-card'
                )}
              </Button>
          </Box>
      </ReusableModal> */}
    </Box>
  );
};;

export default PolicySection;
